import React from 'react';
import {
  View,
} from 'react-native';
import SingleSquareBtn from '../ButtonComponent/SingleSquareBtn';
import {
  Dollar_100, Dollar_300, Dollar_50, Dollar_500,
} from '../../../../utils/DictionaryManagementUtils';

//= ========================================================================

const TableFourSquares = ({
  globJSON, simPlatform,
}) => {
  const myStyles = {
    costContainerSquare: {
      textAlign: 'center',
      marginTop: 10,
    },
    costCoupleSquares: {
      flexDirection: 'row',
      justifyContent: 'center',
      marginTop: 8,
    },
  };

  return (
    <View style={myStyles.costContainerSquare}>
      <View style={myStyles.costCoupleSquares}>
        <SingleSquareBtn
          globJSON={globJSON}
          simPlatform={simPlatform}
          price={Dollar_50}
        />
        <SingleSquareBtn
          globJSON={globJSON}
          simPlatform={simPlatform}
          price={Dollar_100}
        />
      </View>
      <View style={myStyles.costCoupleSquares}>
        <SingleSquareBtn
          globJSON={globJSON}
          simPlatform={simPlatform}
          price={Dollar_300}
        />
        <SingleSquareBtn
          globJSON={globJSON}
          simPlatform={simPlatform}
          price={Dollar_500}
        />
      </View>
    </View>

  );
};
export default TableFourSquares;
